/* eslint-disable */
import React, { useContext, useEffect, useState } from 'react';
import { withRouter } from 'react-router-dom';
import _ from 'lodash';
import { connect } from 'react-redux';
import withForm from 'modules/common/hoc/withForm';
import Modal from 'modules/common/components/Modal';
import useFormValidator from 'useFormValidator';
import Select from 'react-select';
import DateInputPicker from 'modules/common/components/DateInputPicker2';
import PropTypes from 'prop-types';
import moment from 'moment';
import { ModalContext } from 'App';
import NumberFormat from 'react-number-format';
import * as c from '../constant';
import * as actions from '../action';

function UpdateModal({
  updateDiscountPenalty,
  getDiscountPenaltyList,
  updateList,
  history,
  updating,
  discountPenaltyComputationList,
  getRevokedPermitReapplicationOptionList,
  revokedPermitReapplicationOptionList,
  getRetireDelinquentBusinessOptionList,
  retireDelinquentBusinessOptionList,
  getPenaltyDisplayInOr,
  penaltyDisplayInOr,
  getStartInterestOption,
  startInterestOption,
}) {
  const updatedDiscountPenaltyComputation = Object.values(discountPenaltyComputationList).map(item => ({
    ...item,
    value: typeof item.value === "string"
      ? item.value.toLowerCase().replace(/\b\w/g, c => c.toUpperCase())
      : ""
  }));

  const penaltyComputatinOptions = Object.values(updatedDiscountPenaltyComputation)
    .filter((item) => item.code && item.value)
    .map((x) => ({
      label: _.get(x, 'value'),
      value: x.code,
      id: x.code,
    }));

  const revokedPermitReapplicationOptions = (revokedPermitReapplicationOptionList?.data || [])
    .filter((item) => item.code && item.value)
    .map((x) => ({
      label: _.get(x, 'value'),
      value: x.code,
      id: x.code,
    }));

  const retireDelinquentBusinessOptions = (retireDelinquentBusinessOptionList?.data || [])
    .filter((item) => item.code && item.value)
    .map((x) => ({
      label: _.get(x, 'value'),
      value: x.code,
      id: x.code,
    }));

  const penaltyDisplayInOrOptions = (penaltyDisplayInOr?.data || [])
    .filter((item) => item.code && item.value)
    .map((x) => ({
      label: _.get(x, 'value'),
      value: x.code,
      id: x.code,
    }));

  const startInterestOptions = (startInterestOption?.data || [])
    .filter((item) => item.code && item.value)
    .map((x) => ({
      label: _.get(x, 'value'),
      value: x.code,
      id: x.code,
    }));

  const [formData, setFormData] = useState({
    additional_monthly_penalty_percentage: '',
    date_before_penalty_start: '',
    discount_percentage: '',
    initial_penalty_percentage: '',
    last_date_with_discount: '',
    maximum_penalty_percentage: '',
    month_day_before_penalty_update: '',
    year: '',
    gross_additional_percentage: '',
    change_request_processing_fee: 0,
    retirement_processing_fee: 0,
    penalty_computation: '',
    basis_of_penalty: '',
    essential_rate: 0,
    revoked_permit_reapplication: 'allowed',
    retire_delinquent_business: 'allowed',
    penalty_display_in_or: 'penalty_included',
    start_of_interest: 'calendar_year',
    retention_rate: 0,
    minimum_payable_amount: 0,
    payment_reminder: 'no',
    reminder_days_before_due_date: '',
    reminder_apply_in_renewal: 0,
    reminder_apply_in_quarterly: 0,
  });

  const baseValidationRules = {
    date_before_penalty_start: 'required|date',
    last_date_with_discount: 'required|date',
    gross_additional_percentage: 'required|number',
    additional_monthly_penalty_percentage: 'required|number',
    discount_percentage: 'required|number',
    initial_penalty_percentage: 'required|number',
    maximum_penalty_percentage: 'required|number',
    month_day_before_penalty_update: 'required|number',
    change_request_processing_fee: 'required|number',
    retirement_processing_fee: 'required|number',
    penalty_computation: 'required',
    basis_of_penalty: 'required',
    essential_rate: 'required|number',
    revoked_permit_reapplication: 'required',
    retire_delinquent_business: 'required',
    penalty_display_in_or: 'required',
    start_of_interest: 'required',
    retention_rate: 'required',
    minimum_payable_amount: 'required',
    payment_reminder: 'required',
  };

  const validateForm = useFormValidator(formData, baseValidationRules);

  const showPaymentReminderFields =
    _.get(formData, 'payment_reminder') === 'yes';

  useEffect(() => {
    validateForm.onSetObjectRules(
      showPaymentReminderFields
        ? {
            ...baseValidationRules,
            reminder_days_before_due_date: 'required|number',
          }
        : baseValidationRules
    );
    validateForm.validate();
  }, [showPaymentReminderFields]);

  useEffect(() => {
    validateForm.validate();
  }, [formData]);

  const setModal = useContext(ModalContext);

  const handleOnSubmit = (e) => {
    e.preventDefault();

    const args = {
      date_before_penalty_start: moment(
        _.get(formData, 'date_before_penalty_start')
      ).format('YYYY-MM-DD'),
      last_date_with_discount: moment(
        _.get(formData, 'last_date_with_discount')
      ).format('YYYY-MM-DD'),
      gross_additional_percentage: _.get(
        formData,
        'gross_additional_percentage'
      ),
      additional_monthly_penalty_percentage: _.get(
        formData,
        'additional_monthly_penalty_percentage'
      ),
      discount_percentage: _.get(formData, 'discount_percentage'),
      initial_penalty_percentage: _.get(formData, 'initial_penalty_percentage'),
      maximum_penalty_percentage: _.get(formData, 'maximum_penalty_percentage'),
      month_day_before_penalty_update: _.get(
        formData,
        'month_day_before_penalty_update'
      ),
      change_request_processing_fee: _.get(
        formData,
        'change_request_processing_fee'
      ),
      retirement_processing_fee: _.get(formData, 'retirement_processing_fee'),
      penalty_computation: _.get(formData, 'penalty_computation'),
      basis_of_penalty: _.get(formData, 'basis_of_penalty'),
      essential_rate: _.get(formData, 'essential_rate'),
      revoked_permit_reapplication: _.get(formData, 'revoked_permit_reapplication'),
      retire_delinquent_business: _.get(formData, 'retire_delinquent_business'),
      penalty_display_in_or: _.get(formData, 'penalty_display_in_or'),
      start_of_interest: _.get(formData, 'start_of_interest'),
      retention_rate: _.get(formData, 'retention_rate'),
      minimum_payable_amount: _.get(formData, 'minimum_payable_amount'),
      payment_reminder: _.get(formData, 'payment_reminder'),
      reminder_days_before_due_date: showPaymentReminderFields
        ? _.get(formData, 'reminder_days_before_due_date')
        : null,
      reminder_apply_in_renewal: showPaymentReminderFields
        ? !!_.get(formData, 'reminder_apply_in_renewal')
        : false,
      reminder_apply_in_quarterly: showPaymentReminderFields
        ? !!_.get(formData, 'reminder_apply_in_quarterly')
        : false,
    };

    updateDiscountPenalty(args, () => {
      setModal({ isOpen: false });
      getDiscountPenaltyList();
      history.push(`/bpls/settings/discount-penalty`);
    });
  };

  const handleDropDownChange = (key) => (e) => {
    setFormData({
      ...formData,
      [key]: e ? e.value : '',
    });
  };

  const closeModal = (e) => {
    e.preventDefault();
    setModal({ isOpen: false });
  };

  const toYesNo = (value) => {
    if (value === true || value === 1 || value === '1' || value === 'yes' || value === 'allowed') {
      return 'yes';
    }
    return 'no';
  };

  const toFlag = (value) => (value === true || value === 1 || value === '1' ? 1 : 0);

  const onSetFormData = () => {
    if (!_.isEmpty(updateList)) {
      const args = {
        ...updateList,
      };
      const picked = _.pick(args, _.keys(c.FORM_DATA));
      setFormData((prev) => ({
        ...prev,
        ...picked,
        payment_reminder: toYesNo(
          _.get(args, 'payment_reminder', prev.payment_reminder)
        ),
        reminder_apply_in_renewal: toFlag(_.get(args, 'reminder_apply_in_renewal')),
        reminder_apply_in_quarterly: toFlag(_.get(args, 'reminder_apply_in_quarterly')),
        reminder_days_before_due_date:
          _.get(args, 'reminder_days_before_due_date') ?? prev.reminder_days_before_due_date,
      }));
    }
  };

  useEffect(() => {
    onSetFormData();
    getRevokedPermitReapplicationOptionList();
    getRetireDelinquentBusinessOptionList();
    getPenaltyDisplayInOr();
    getStartInterestOption();
  }, []);

  const onChangeDate =
    (key) =>
    ({ target: { value } }) => {
      setFormData({
        ...formData,
        [key]: value,
      });
    };

  const onChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const onCheck = (e) => {
    const { name, checked } = e.target;
    setFormData({
      ...formData,
      [name]: checked ? 1 : 0,
    });
  };

  useEffect(() => {
    validateForm.validate();
  }, [Object.values(formData).join(',')]);

  const MAX_VAL = 31;
  const withValueCap = (inputObj) => {
    const { value } = inputObj;
    if (value <= MAX_VAL) return true;
    return false;
  };

  const withReminderDaysCap = ({ floatValue }) => {
    if (typeof floatValue === 'undefined') return true;
    return floatValue >= 0 && floatValue <= 30;
  };

  return (
    <Modal.Body>
      <form onSubmit={handleOnSubmit}>
        <div className="row ml-auto text-primary font-weight-bold mb-2">
          PENALTY SCHEDULE
        </div>
        <div className="row">
          <div className="col-6 form-group">
            <label
              htmlFor="date_before_penalty_start"
              className="full-label mb-0"
            >
              Last Day of Renewal Period:
              {validateForm.renderMessage('date_before_penalty_start')}
            </label>
            <DateInputPicker
              className="form-control"
              dateFormat="MM/DD/YYYY"
              onChange={onChangeDate('date_before_penalty_start')}
              value={_.get(formData, 'date_before_penalty_start')}
            />
          </div>
          <div className="col-6 form-group">
            <label htmlFor="last_name" className="full-label mb-0">
              First Month Day of Penalty:
              {validateForm.renderMessage('month_day_before_penalty_update')}
            </label>
            <NumberFormat
              name="month_day_before_penalty_update"
              id="month_day_before_penalty_update"
              placeholder="1 - 31"
              allowLeadingZeros
              className="form-control"
              onValueChange={(values) => {
                const { floatValue } = values;
                setFormData({
                  ...formData,
                  month_day_before_penalty_update: floatValue,
                });
              }}
              displayType="input"
              isNumericString
              value={
                _.get(
                  formData,
                  'month_day_before_penalty_update'
                )?.toString() || ''
              }
              isAllowed={withValueCap}
            />
          </div>
          <div className="col-6 form-group">
            <label
              htmlFor="last_date_with_discount"
              className="full-label mb-0"
            >
              Last Date with Discount:
              {validateForm.renderMessage('last_date_with_discount')}
            </label>
            <DateInputPicker
              className="form-control"
              dateFormat="MM/DD/YYYY"
              onChange={onChangeDate('last_date_with_discount')}
              value={_.get(formData, 'last_date_with_discount')}
            />
          </div>
          <div className='col-6 form-group'>
            <label
              htmlFor='start_of_interest'
              className='full-label mb-0'
            >
              Start of Interest: 
              {validateForm.renderMessage('start_of_interest')}
            </label>
            <Select
              options={startInterestOptions}
              placeholder=""
              onChange={handleDropDownChange('start_of_interest')}
              value={
                startInterestOptions.filter(
                  (item) =>
                    _.get(formData, 'start_of_interest') ===
                    _.get(item, 'value')
                ) || ''
              }
            />
          </div>
        </div>
        <div className="row ml-auto text-primary font-weight-bold mb-2">
          ASSESSMENT RATES AND INTEREST TIERS
        </div>
        <div className='row'>
          <div className="col-6 form-group">
            <label htmlFor="essential_rate" className="full-label mb-0">
              Essential Rate:
              {validateForm.renderMessage('essential_rate')}
            </label>
            <NumberFormat
              name="essential_rate"
              id="essential_rate"
              placeholder="0.00"
              fixedDecimalScale={2}
              allowLeadingZeros
              className="form-control"
              onValueChange={(values) => {
                const { floatValue } = values;
                setFormData({
                  ...formData,
                  essential_rate: floatValue || '',
                });
              }}
              displayType="input"
              isNumericString
              thousandSeparator
              value={_.get(formData, 'essential_rate')?.toString() || ''}
            />
          </div>
          <div className="col-6 form-group">
            <label htmlFor="last_name" className="full-label mb-0">
              Monthly Interest Rate:
              {validateForm.renderMessage(
                'additional_monthly_penalty_percentage'
              )}
            </label>
            <NumberFormat
              name="additional_monthly_penalty_percentage"
              id="additional_monthly_penalty_percentage"
              placeholder="0.00"
              fixedDecimalScale={2}
              allowLeadingZeros
              className="form-control"
              onValueChange={(values) => {
                const { floatValue } = values;
                setFormData({
                  ...formData,
                  additional_monthly_penalty_percentage: floatValue,
                });
              }}
              displayType="input"
              isNumericString
              thousandSeparator
              decimalScale={5}
              value={
                _.get(formData, 'additional_monthly_penalty_percentage', '')?.toString() || ''
              }
            />
          </div>
          <div className="col-6 form-group">
            <label htmlFor="last_name" className="full-label mb-0">
              Discount Rate:
              {validateForm.renderMessage('discount_percentage')}
            </label>
            <NumberFormat
              name="discount_percentage"
              id="discount_percentage"
              placeholder="0.00"
              fixedDecimalScale={2}
              allowLeadingZeros
              className="form-control"
              onValueChange={(values) => {
                const { floatValue } = values;
                setFormData({
                  ...formData,
                  discount_percentage: floatValue,
                });
              }}
              displayType="input"
              isNumericString
              thousandSeparator
              value={_.get(formData, 'discount_percentage')?.toString() || ''}
            />
          </div>
          <div className="col-6 form-group">
            <label htmlFor="last_name" className="full-label mb-0">
              Maximum Monthly Interest Rate:
              {validateForm.renderMessage('maximum_penalty_percentage')}
            </label>
            <NumberFormat
              name="maximum_penalty_percentage"
              id="maximum_penalty_percentage"
              placeholder="0.00"
              fixedDecimalScale={2}
              allowLeadingZeros
              className="form-control"
              onValueChange={(values) => {
                const { floatValue } = values;
                setFormData({
                  ...formData,
                  maximum_penalty_percentage: floatValue,
                });
              }}
              displayType="input"
              isNumericString
              thousandSeparator
              value={
                _.get(formData, 'maximum_penalty_percentage')?.toString() || ''
              }
            />
          </div>
          <div className="col-6 form-group">
            <label htmlFor="last_name" className="full-label mb-0">
              Gross Additional Rate:
              {validateForm.renderMessage('gross_additional_percentage')}
            </label>
            <NumberFormat
              name="gross_additional_percentage"
              id="gross_additional_percentage"
              placeholder="0.00"
              fixedDecimalScale={2}
              allowLeadingZeros
              className="form-control"
              onValueChange={(values) => {
                const { floatValue } = values;
                setFormData({
                  ...formData,
                  gross_additional_percentage: floatValue,
                });
              }}
              displayType="input"
              isNumericString
              thousandSeparator
              value={
                _.get(formData, 'gross_additional_percentage')?.toString() || ''
              }
            />
          </div>
          <div className="col-6 form-group">
            <label htmlFor="last_name" className="full-label mb-0">
              Surcharge Rate:
              {validateForm.renderMessage('initial_penalty_percentage')}
            </label>
            <NumberFormat
              name="initial_penalty_percentage"
              id="initial_penalty_percentage"
              placeholder="0.00"
              fixedDecimalScale={2}
              allowLeadingZeros
              className="form-control"
              onValueChange={(values) => {
                const { floatValue } = values;
                setFormData({
                  ...formData,
                  initial_penalty_percentage: floatValue,
                });
              }}
              displayType="input"
              isNumericString
              thousandSeparator
              value={
                _.get(formData, 'initial_penalty_percentage')?.toString() || ''
              }
            />
          </div>
          <div className="col-6 form-group">
            <label
              htmlFor="last_date_with_discount"
              className="full-label mb-0"
            >
              Interest Computation:
              {validateForm.renderMessage('penalty_computation')}
            </label>
            <Select
              options={penaltyComputatinOptions}
              placeholder="Select Penalty Computation"
              onChange={handleDropDownChange('penalty_computation')}
              value={
                penaltyComputatinOptions.filter(
                  (item) =>
                    _.get(formData, 'penalty_computation') ===
                    _.get(item, 'value')
                ) || ''
              }
            />
          </div>
          <div className="col-6 form-group">
            <label
              htmlFor="last_date_with_discount"
              className="full-label mb-0"
            >
              Basis of Penalty:
              {validateForm.renderMessage('basis_of_penalty')}
            </label>
            <Select
              options={c.BASIS_OF_PENALTY}
              placeholder="Select Basis of Penalty"
              onChange={handleDropDownChange('basis_of_penalty')}
              value={
                c.BASIS_OF_PENALTY.filter(
                  (item) =>
                    _.get(formData, 'basis_of_penalty') === _.get(item, 'value')
                ) || ''
              }
            />
          </div>
        </div>
        <div className="row ml-auto text-primary font-weight-bold mb-2">
          SERVICE FEES 
        </div>
        <div className='row'>
          <div className="col-6 form-group">
            <label htmlFor="last_name" className="full-label mb-0">
              Retirement Processing Fee:
              {validateForm.renderMessage('retirement_processing_fee')}
            </label>
            <NumberFormat
              name="retirement_processing_fee"
              id="retirement_processing_fee"
              placeholder="0.00"
              fixedDecimalScale={2}
              allowLeadingZeros
              className="form-control"
              onValueChange={(values) => {
                const { floatValue } = values;
                setFormData({
                  ...formData,
                  retirement_processing_fee: floatValue,
                });
              }}
              displayType="input"
              isNumericString
              thousandSeparator
              value={
                _.get(formData, 'retirement_processing_fee')?.toString() || ''
              }
            />
          </div>
          <div className="col-6 form-group">
            <label htmlFor="last_name" className="full-label mb-0">
              Change Request Processing Fee:
              {validateForm.renderMessage('change_request_processing_fee')}
            </label>
            <NumberFormat
              name="change_request_processing_fee"
              id="change_request_processing_fee"
              placeholder="0.00"
              fixedDecimalScale={2}
              allowLeadingZeros
              className="form-control"
              onValueChange={(values) => {
                const { floatValue } = values;
                setFormData({
                  ...formData,
                  change_request_processing_fee: floatValue,
                });
              }}
              displayType="input"
              isNumericString
              thousandSeparator
              value={
                _.get(formData, 'change_request_processing_fee')?.toString() ||
                ''
              }
            />
          </div>
        </div>
        <div className="row ml-auto text-primary font-weight-bold mb-2">
          SUPPLEMENTAL CONTROLS & DISPLAYS
        </div>
        <div className='row'>
          <div className='col-6 form-group'>
            <label
              htmlFor='revoked_permit_reapplication'
              className='full-label mb-0'
            >
              Revoke Permit: 
              {validateForm.renderMessage('revoked_permit_reapplication')}
            </label>
            <Select
              options={revokedPermitReapplicationOptions}
              placeholder=""
              onChange={handleDropDownChange('revoked_permit_reapplication')}
              value={
                revokedPermitReapplicationOptions.filter(
                  (item) =>
                    _.get(formData, 'revoked_permit_reapplication') ===
                    _.get(item, 'value')
                ) || ''
              }
            />
          </div>
          <div className='col-6 form-group'>
            <label
              htmlFor='retire_delinquent_business'
              className='full-label mb-0'
            >
              Retire Delinquent Business (Previous Year only):
              {validateForm.renderMessage('retire_delinquent_business')}
            </label>
            <Select
              options={retireDelinquentBusinessOptions}
              placeholder=""
              onChange={handleDropDownChange('retire_delinquent_business')}
              value={
                retireDelinquentBusinessOptions.filter(
                  (item) =>
                    _.get(formData, 'retire_delinquent_business') ===
                    _.get(item, 'value')
                ) || ''
              }
            />
          </div>
          <div className='col-6 form-group'>
            <label
              htmlFor='penalty_display_in_or'
              className='full-label mb-0'
            >
              Penalty Display in View OR: 
              {validateForm.renderMessage('penalty_display_in_or')}
            </label>
            <Select
              options={penaltyDisplayInOrOptions}
              placeholder=""
              onChange={handleDropDownChange('penalty_display_in_or')}
              value={
                penaltyDisplayInOrOptions.filter(
                  (item) =>
                    _.get(formData, 'penalty_display_in_or') ===
                    _.get(item, 'value')
                ) || ''
              }
            />
          </div>
        </div>
        <div className="row ml-auto text-primary font-weight-bold mb-2">
          TAX CREDIT APPLICATION
        </div>
        <div className='row'>
          <div className="col-6 form-group">
            <label htmlFor="retention_rate" className="full-label mb-0">
              Retention Rate:
              {validateForm.renderMessage('retention_rate')}
            </label>
            <NumberFormat
              name="retention_rate"
              id="retention_rate"
              placeholder="0.00"
              fixedDecimalScale={2}
              allowLeadingZeros
              className="form-control"
              onValueChange={(values) => {
                const { floatValue } = values;
                setFormData({
                  ...formData,
                  retention_rate: floatValue,
                });
              }}
              displayType="input"
              isNumericString
              thousandSeparator
              decimalScale={2}
              value={_.get(formData, 'retention_rate')?.toString() || ''}
            />
          </div>
          <div className="col-6 form-group">
            <label htmlFor="minimum_payable_amount" className="full-label mb-0">
              Minimum Payable Amount:
              {validateForm.renderMessage(
                'minimum_payable_amount'
              )}
            </label>
            <NumberFormat
              name="minimum_payable_amount"
              id="minimum_payable_amount"
              placeholder="0.00"
              fixedDecimalScale={2}
              allowLeadingZeros
              className="form-control"
              onValueChange={(values) => {
                const { floatValue } = values;
                setFormData({
                  ...formData,
                  minimum_payable_amount: floatValue,
                });
              }}
              displayType="input"
              isNumericString
              thousandSeparator
              value={
                _.get(formData, 'minimum_payable_amount', '')?.toString() || ''
              }
            />
          </div>
        </div>

        <div className="row ml-auto text-primary font-weight-bold mb-2">
          EMAIL & SMS
        </div>
        <div className="row">
          <div className="col-6 form-group">
            <label htmlFor="payment_reminder" className="full-label mb-0">
              Payment Reminder:
              {validateForm.renderMessage('payment_reminder')}
            </label>
            <Select
              options={c.PAYMENT_REMINDER_OPTIONS}
              placeholder=""
              onChange={handleDropDownChange('payment_reminder')}
              value={
                c.PAYMENT_REMINDER_OPTIONS.filter(
                  (item) =>
                    _.get(formData, 'payment_reminder') ===
                    _.get(item, 'value')
                ) || ''
              }
              menuPortalTarget={document.body}
              styles={{
                menuPortal: (base) => ({ ...base, zIndex: 9999 }),
              }}
            />
          </div>
          {showPaymentReminderFields && (
            <div className="col-6 form-group">
              <label
                htmlFor="reminder_days_before_due_date"
                className="full-label mb-0"
              >
                Days before Due Date:
                {validateForm.renderMessage('reminder_days_before_due_date')}
              </label>
              <NumberFormat
                name="reminder_days_before_due_date"
                id="reminder_days_before_due_date"
                placeholder="e.g. 3"
                allowLeadingZeros={false}
                allowNegative={false}
                isAllowed={withReminderDaysCap}
                className="form-control"
                onValueChange={(values) => {
                  const { floatValue } = values;
                  setFormData({
                    ...formData,
                    reminder_days_before_due_date:
                      typeof floatValue === 'undefined' ? '' : floatValue,
                  });
                }}
                displayType="input"
                isNumericString
                value={
                  _.get(formData, 'reminder_days_before_due_date')?.toString() || ''
                }
              />
            </div>
          )}
          {showPaymentReminderFields && (
            <>
              <div className="col-6 form-group d-flex align-items-center justify-content-between">
                <label htmlFor="reminder_apply_in_renewal" className="mb-0">
                  Apply in Renewal
                </label>
                <div className="custom-control custom-switch m-0">
                  <input
                    id="reminder_apply_in_renewal"
                    name="reminder_apply_in_renewal"
                    type="checkbox"
                    className="custom-control-input"
                    checked={!!_.get(formData, 'reminder_apply_in_renewal')}
                    onChange={onCheck}
                  />
                  <label
                    htmlFor="reminder_apply_in_renewal"
                    className="custom-control-label"
                  />
                </div>
              </div>
              <div className="col-6 form-group d-flex align-items-center justify-content-between">
                <label htmlFor="reminder_apply_in_quarterly" className="mb-0">
                  Apply in Quarterly
                </label>
                <div className="custom-control custom-switch m-0">
                  <input
                    id="reminder_apply_in_quarterly"
                    name="reminder_apply_in_quarterly"
                    type="checkbox"
                    className="custom-control-input"
                    checked={!!_.get(formData, 'reminder_apply_in_quarterly')}
                    onChange={onCheck}
                  />
                  <label
                    htmlFor="reminder_apply_in_quarterly"
                    className="custom-control-label"
                  />
                </div>
              </div>
            </>
          )}
        </div>

        <div className="d-flex justify-content-center">
          <button
            disabled={updating || !validateForm.response.is_passed}
            type="submit"
            className="mt-3 btn btn-primary cms-bg-color-primary cms-outline-primary     mr-3"
          >
            <span className="font-weight-bold">
              {updating ? <i className="fa fa-spin fa-spinner" /> : `Submit`}
            </span>{' '}
          </button>
          <button
            type="button"
            onClick={closeModal}
            className="mt-3 btn btn-dark "
          >
            <span className="font-weight-bold">Cancel</span>
          </button>
        </div>
      </form>
    </Modal.Body>
  );
}

UpdateModal.propTypes = {
  updateList: PropTypes.instanceOf(Object).isRequired,
  updateDiscountPenalty: PropTypes.instanceOf(Function).isRequired,
  getDiscountPenaltyList: PropTypes.instanceOf(Function).isRequired,
  discountPenaltyComputationList: PropTypes.instanceOf(Object).isRequired,
  history: PropTypes.instanceOf(Object).isRequired,
  updating: PropTypes.bool.isRequired,
  getRevokedPermitReapplicationOptionList: PropTypes.instanceOf(Function).isRequired,
  revokedPermitReapplicationOptionList: PropTypes.instanceOf(Object).isRequired,
  getRetireDelinquentBusinessOptionList: PropTypes.instanceOf(Function).isRequired,
  retireDelinquentBusinessOptionList: PropTypes.instanceOf(Object).isRequired,
  getPenaltyDisplayInOr: PropTypes.instanceOf(Function).isRequired,
  penaltyDisplayInOr: PropTypes.instanceOf(Object).isRequired,
  getStartInterestOption: PropTypes.instanceOf(Function).isRequired,
  startInterestOption: PropTypes.instanceOf(Object).isRequired,
};

const mapStateToProps = ({ api }) => ({
  updating: api.loading.indexOf(c.UPDATE_DISCOUNT_PENALTY) > -1,
  discountPenaltyComputationList:
    _.get(api, `${c.GET_PENALTY_COMPUTATION_LIST}.item`) || [],
  revokedPermitReapplicationOptionList: _.get(api, `${c.GET_REVOKED_PERMIT_REAPPLICATION_OPTION_LIST}.res`) || [],
  retireDelinquentBusinessOptionList:
    _.get(api, `${c.GET_RETIRE_DELINQUENT_BUSINESS_OPTION_LIST}.res`) || [],
  penaltyDisplayInOr: _.get(api, `${c.GET_PENALTY_DISPLAY_IN_OR}.res`) || [],
  startInterestOption: _.get(api, `${c.GET_START_INTEREST_OPTION}.res`) || [],
});

const enhance = _.flowRight([
  withForm,
  withRouter,
  connect(mapStateToProps, {
    ...actions,
  }),
]);

export default enhance(UpdateModal);
